import axios from "../api"
import { getToken } from "../util/util"
import { toast } from "react-toastify"
import { FormattedMessage } from "react-intl"

axios.defaults.timeout = 1000000

/**
 * @param {*} body
 * @returns {Promise<{message: string; cvId: string; file_name: string}>}
 */
export const uploadCV = (body) =>
  axios
    .post("/cv/upload", body, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
    })
    .then((response) => response.data)

export const getCV = (key) =>
  axios.get(`/cv/get?key=${key}`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  }).then((res) => res.data)

export const updateCV = (body) =>
  axios
    .put(`/cv/${body.id}`, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      },
    })
    .then((res) => res.data)
    .catch((_err) => {
      toast.error(<FormattedMessage id="toast.unableToUpdateCV" />);
    })

export const getCVFile = (id) =>
  axios.get(`/cv/${id}/file`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    },
  })
  .then((response) => response.data)

export const deleteCvs = (keys) =>
  axios.post(
    `/cv/delete`,
    { keys },
    { headers: {
      Authorization: `Bearer ${getToken()}`,
      "Cache-Control": "no-cache",
    }},
  )

export const getCvs = (limit = 40, offset = 0) => //TODO: change it to a CONST ?
  axios
    .post(
      `/cv/getAll?offset=${offset}&limit=${limit}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Cache-Control": "no-cache",
        }
      }
    )
    .then((res) => ({
      cvs: res.data.cvs,
      total: res.data.pagination.total,
      limit: res.data.pagination.limit,
      offset: res.data.pagination.offset,
      hasMore: res.data.pagination.has_more
    }))

export const importCvs = (body) =>
  axios
    .post(`/cv/import-cv`, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      }
    })
    .then((res) => res.data)

export const getCVsStatus = (ids) =>
  axios
    .post(`/cv/status`, { ids }, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Cache-Control": "no-cache",
      }
    })
    .then((res) => res.data)
